import React from 'react'
import Box, { Text } from 'components/Box'
import styled from 'styled-components'

export const ErrorContainer = styled(Box)`
  box-sizing: border-box;
  margin: auto 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 100%;
  justify-content: center;
`

const GenericErrorState = () => (
  <ErrorContainer>
    <Text fontWeight="semibold" color="text.dark.primary" mb={2}>
      Something went wrong
    </Text>
    <Text color="text.dark.secondary" mt={2}>
      We’re aware of the issue and will fix it as soon as possible. You can find
      more information on our{' '}
      <a href="https://status.sketch.com/">Status Page</a>.
    </Text>
  </ErrorContainer>
)

export default GenericErrorState
